import { Icon } from './ui.jsx';

/* ---------- Footer ---------- */
export const Footer = () => (
  <footer style={{ background: 'var(--ink)', color: 'var(--paper-2)', marginTop: 80 }}>
    <div className="container-w" style={{ padding: '80px 40px 40px' }}>
      <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 60, alignItems: 'flex-start' }}>
        <div>
          <div className="serif footer-lead" style={{ fontSize: 54, lineHeight: 0.95, fontStyle: 'italic', maxWidth: 520 }}>
            L'art se trouve là où vous êtes déjà.
          </div>
          <div className="row gap-3 wrap" style={{ marginTop: 32 }}>
            <a href="/publier" className="btn btn-accent">
              Publier mon parcours <Icon name="arrow-right" size={14} />
            </a>
            <a href="/parcours" className="btn btn-ghost" style={{ borderColor: 'var(--paper-2)', color: 'var(--paper-2)' }}>
              Explorer les parcours
            </a>
          </div>
        </div>
        <div className="stack gap-4">
          <div className="mono" style={{ color: 'var(--paper-3)' }}>Explorer</div>
          <div className="stack gap-3">
            <a href="/parcours" style={{ color: 'var(--paper-2)', fontSize: 14 }}>Parcours</a>
            <a href="/publier" style={{ color: 'var(--paper-2)', fontSize: 14 }}>Publier mon parcours</a>
          </div>
        </div>
      </div>
      <div
        className="footer-bottom between wrap"
        style={{ marginTop: 80, paddingTop: 24, borderTop: '1px solid rgba(247,241,229,0.12)', gap: 16 }}
      >
        <div className="row gap-3">
          <img
            src="/assets/logo-parcours-artistes-white.png"
            alt="parcours d'artistes"
            style={{ width: 'auto', display: 'block', height: '44px' }}
          />
          <span className="mono" style={{ color: 'var(--paper-3)' }}>© 2026 · Parcours Artiste</span>
        </div>
        <div className="mono" style={{ color: 'var(--paper-3)' }}>By Mozaika</div>
      </div>
    </div>
  </footer>
);
